import { parseISO, isValid, differenceInCalendarDays, format } from 'date-fns';

export function parseIsoDay(iso: string): Date | null {
	if (!iso) return null;
	try {
		const date = parseISO(iso);
		return isValid(date) ? date : null;
	} catch {
		return null;
	}
}

export function toIsoDay(date: Date): string {
	return format(date, 'yyyy-MM-dd');
}

export function formatDayMonth(iso: string, refYear?: number): string {
	const date = parseIsoDay(iso);
	if (!date) return iso;
	const year = date.getFullYear();
	const month = date.getMonth() + 1;
	const day = date.getDate();
	const formatted = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}`;
	if (refYear && year !== refYear) {
		return `${formatted}/${year}`;
	}
	return formatted;
}

export function formatPeriodRange(startIso: string, endIso: string, refYear: number): string {
	const startDate = parseIsoDay(startIso);
	const endDate = parseIsoDay(endIso);
	if (!startDate || !endDate) return `${startIso} → ${endIso}`;

	const startFormatted = formatDayMonth(startIso, refYear);
	const endFormatted = formatDayMonth(endIso, refYear);

	return `${startFormatted} → ${endFormatted}`;
}

export function daysBetween(fromIso: string, toIso: string): number {
	const from = parseIsoDay(fromIso);
	const to = parseIsoDay(toIso);
	if (!from || !to) return 0;
	return differenceInCalendarDays(to, from);
}
